import {Box, Flex, IconWithText, Tag} from 'exsportia-components'
import {isFunction} from 'formik'
import {FC, ReactElement, useMemo} from 'react'

import {Button} from '../../ui/components/button/button'
import {ExsportiaAccRectBg} from '../../ui/components/exsportia-acc-rect-bg/exsportia-acc-rect-bg'
import {useLocale} from '../../utils/i18n'
import {NO_USER_PHOTO} from '../../utils/remote-content'
import {ExsportiaLogoWithText} from '../exsportia-logo/exsportia-logo-with-text'

export type UserExsportiaCardProps = {
  name?: string
  subText?: string
  avatar?: ReactElement | string | null
  venueNames?: string[]
  handleOpenQr?: (() => void) | null
}

const iconWithTextSettings = {
  icon: {
    width: '48px',
    height: '48px',
    overflow: 'hidden',
    borderRadius: '50%',
  },
  title: {
    fontSize: '20px',
  },
}

const tagSettings = {bg: 'bg'}

export const UserExsportiaCard: FC<UserExsportiaCardProps> = ({
  name,
  avatar,
  venueNames = [],
  subText,
  handleOpenQr,
}) => {
  const {l} = useLocale()
  const icon = useMemo(
    () => (
      <Box
        width='48px'
        height='48px'
        backgroundSize='cover'
        background={`url(${avatar || NO_USER_PHOTO}) no-repeat center`}
      />
    ),
    [avatar],
  )

  return (
    <Flex
      borderRadius='16px'
      p='16px'
      width='100%'
      gap='24px'
      overflow='hidden'
      border='1px solid #00103D1F'
      background='linear-gradient(260.17deg, #FFFFFF 4.74%, #F7F7F7 98.99%)'
      flexDirection='column'
      position='relative'
    >
      <ExsportiaLogoWithText text={l('account')} />
      <Flex
        zIndex={0}
        position='absolute'
        right='0'
        top='0'
      >
        <ExsportiaAccRectBg />
      </Flex>
      <Flex zIndex='1'>
        <IconWithText
          icon={icon}
          title={name}
          subText={subText}
          settings={iconWithTextSettings}
        />
      </Flex>
      {venueNames.length > 0 && (
        <Flex
          width='100%'
          flexWrap='wrap'
          gap='4px'
          zIndex='1'
        >
          {venueNames.map((venueName, index) => (
            <Tag
              key={index}
              text={venueName}
              settings={tagSettings}
              styleType='displayValue'
            />
          ))}
        </Flex>
      )}
      {isFunction(handleOpenQr) && (
        <Button
          icon='qrCode'
          type='secondary'
          onClick={handleOpenQr}
        >
          <Flex pl='8px'>{l('qrCode')}</Flex>
        </Button>
      )}
    </Flex>
  )
}
